import React, { useEffect, useState } from "react";
import { FaArrowLeft } from "react-icons/fa6";
import { IoSettings } from "react-icons/io5";
import SlippageSettings from "./SlippageSettings";
import { useParams, useNavigate } from "react-router-dom";
import { useActiveAccount, useActiveWalletChain } from "thirdweb/react";
import {
    getErc20Contract,
    getLPContract,
    getRouterContract,
} from "../contexts/thirdWebClient";
import {
    allowance,
    approve,
    balanceOf,
    getCurrencyMetadata,
} from "thirdweb/extensions/erc20";
import { list as tokenList } from "../contexts/SelectTokenDATA";
import {
    prepareContractCall,
    readContract,
    sendTransaction as sendTx,
} from "thirdweb";
import { ethers } from "ethers";
import { routerAddress } from "../contexts/config";
import { toast } from "react-toastify";

const getTokenIcon = (address) => {
    const token = tokenList.find(
        (t) => t.address.toLowerCase() === address?.toLowerCase(),
    );
    return token?.img || null;
};

const RemoveLiquidity = () => {
    const navigate = useNavigate();
    const [value, setValue] = useState(0);
    const [loading, setLoading] = useState(false);
    const [settingsOpen, setSettingsOpen] = useState(false);
    const [slippage, setSlippage] = useState(() => {
        const saved = localStorage.getItem("dexora_slippage");
        return saved ? parseFloat(saved) : 1;
    });

    const { pairAddress} = useParams();

    const add = useActiveAccount();
    const [address, setAddress] = useState("");
    const chain = useActiveWalletChain();

    useEffect(() => {
        if (add && add.address && chain && pairAddress) {
            setAddress(add.address);
            fetchLpDetails(pairAddress, add.address, chain);
        }
    }, [add, chain, pairAddress]);

    const [lpDetails, setLpDetails] = useState({});
    const [dataLoaded, setDataLoaded] = useState(false);

    const fetchLpDetails = async (pairAddress, address, chain) => {
        try {
            setDataLoaded(false);
            const contract = getErc20Contract(pairAddress, chain);
            let currencyMetadata = await getCurrencyMetadata({ contract });
            let pairTotalSupply = await readContract({
                contract,
                method: "function totalSupply() view returns (uint256)",
                params: [],
            });
            let userBalance = await balanceOf({
                contract,
                address: address,
            });
            let approvedAmount = await allowance({
                contract,
                owner: address,
                spender: routerAddress,
            });

            const lpContract = getLPContract(pairAddress, chain);

            let token0Address = await readContract({
                contract: lpContract,
                method: "function token0() view returns (address)",
                params: [],
            });
            let token1Address = await readContract({
                contract: lpContract,
                method: "function token1() view returns (address)",
                params: [],
            });

            const Token0contract = getErc20Contract(token0Address, chain);

            let tokenOMetaData = await getCurrencyMetadata({
                contract: Token0contract,
            });
            let tokenOUserBalance = await balanceOf({
                contract: Token0contract,
                address: pairAddress,
            });

            const Token1contract = getErc20Contract(token1Address, chain);
            let token1MetaData = await getCurrencyMetadata({
                contract: Token1contract,
            });
            let token1UserBalance = await balanceOf({
                contract: Token1contract,
                address: pairAddress,
            });

            let userShare =
                (Number(
                    ethers.formatUnits(userBalance, currencyMetadata?.decimals),
                ) *
                    100) /
                Number(
                    ethers.formatUnits(
                        pairTotalSupply,
                        currencyMetadata?.decimals,
                    ),
                );

            const routerContract = await getRouterContract(chain);
            let token0Price = await readContract({
                contract: routerContract,
                method: "function quote(uint256 amountA, uint256 reserveA, uint256 reserveB) pure returns (uint256 amountB)",
                params: [
                    ethers.parseUnits("1", tokenOMetaData?.decimals),
                    tokenOUserBalance,
                    token1UserBalance,
                ],
            });
            let token1Price = await readContract({
                contract: routerContract,
                method: "function quote(uint256 amountA, uint256 reserveA, uint256 reserveB) pure returns (uint256 amountB)",
                params: [
                    ethers.parseUnits("1", token1MetaData?.decimals),
                    token1UserBalance,
                    tokenOUserBalance,
                ],
            });

            let pairData = {
                pairAddress: pairAddress,
                token0Address,
                token1Address,
                currencyMetadata,
                token0Price: Number(
                    ethers.formatUnits(token0Price, token1MetaData?.decimals),
                ),
                token1Price: Number(
                    ethers.formatUnits(token1Price, tokenOMetaData?.decimals),
                ),
                lpName:
                    tokenOMetaData?.symbol +
                    "-" +
                    token1MetaData?.symbol +
                    " LP",
                lpTotalSupply: Number(
                    ethers.formatUnits(
                        pairTotalSupply,
                        currencyMetadata?.decimals,
                    ),
                ),
                approvedBalance: Number(
                    ethers.formatUnits(
                        approvedAmount,
                        currencyMetadata?.decimals,
                    ),
                ),
                lpUserBalance: Number(
                    ethers.formatUnits(userBalance, currencyMetadata?.decimals),
                ),
                userShare: userShare,
                tokenOMetaData,
                token1MetaData,
                token0Name: tokenOMetaData?.name,
                token0Symbol: tokenOMetaData?.symbol,
                token0UserBalance:
                    (userShare *
                        Number(
                            ethers.formatUnits(
                                tokenOUserBalance,
                                tokenOMetaData?.decimals,
                            ),
                        )) /
                    100,
                token1Name: token1MetaData?.name,
                token1Symbol: token1MetaData?.symbol,
                token1UserBalance:
                    (userShare *
                        Number(
                            ethers.formatUnits(
                                token1UserBalance,
                                token1MetaData?.decimals,
                            ),
                        )) /
                    100,
            };
            console.log("%c Line:85 🍰 pairData", "color:#6ec1c2", pairData);
            setLpDetails(pairData);
            setDataLoaded(true);
        } catch (error) {
            setDataLoaded(false);
            console.log("%c Line:47 🍉 error", "color:#42b983", error);
        }
    };

    const approveTokenFun = async (tokenAddress) => {
        try {
            setLoading(true);
            // const { mutate: sendTransaction } = useSendTransaction();
            const contract = getErc20Contract(tokenAddress, chain);
            const transaction = approve({
                contract,
                spender: routerAddress,
                amount: 1000,
            });
            console.log(
                "%c Line:117 🍢 transaction",
                "color:#ed9ec7",
                transaction,
                add,
            );
            const tx = await sendTx({ transaction, account: add });
            console.log("%c Line:118 🥔 tx", "color:#93c0a4", tx);
            toast.success("Token approved");
            // Refetch LP details so approvedBalance updates and button switches
            await fetchLpDetails(pairAddress, address, chain);
            setLoading(false);
        } catch (error) {
            toast.error(error?.message);
            setLoading(false);

            console.log("%c Line:111 🍫 error", "color:#ed9ec7", error);
        }
    };

    const [token0Amount, setToken0Amount] = useState(0);
    const [token1Amount, setToken1Amount] = useState(0);

    const updateValue = (value) => {
        let val = parseFloat(value);
        setValue(value);
        let tokenAmount = (val * lpDetails.token0UserBalance) / 100;
        setToken0Amount(tokenAmount);
        let tokenBAmount = (val * lpDetails.token1UserBalance) / 100;
        setToken1Amount(tokenBAmount);
    };

    // Calculate minimum amount with slippage
    const calculateMinAmount = (amount, decimals) => {
        try {
            const slippageMultiplier = (100 - slippage) / 100;
            const minAmount = parseFloat(amount) * slippageMultiplier;
            return ethers.parseUnits(minAmount.toFixed(decimals), decimals);
        } catch (error) {
            console.log("Error calculating min amount:", error);
            return "1"; // Fallback
        }
    };

    const removeLiquidity = async () => {
        try {
            if (value <= 0) {
                toast.error("Please Enter Valid amount");
                return;
            }
            console.log("%c Line:236 🥕 value", "color:#b03734", value);
            const contract = getRouterContract(chain);

            // eslint-disable-next-line no-unused-vars
            let token1amount = ethers.parseUnits(
                `${token0Amount.toFixed(3)}`,
                lpDetails?.tokenOMetaData?.decimals,
            );

            // eslint-disable-next-line no-unused-vars
            let token2amount = ethers.parseUnits(
                `${token1Amount.toFixed(3)}`,
                lpDetails?.token1MetaData?.decimals,
            );

            let amount = (value * lpDetails.lpUserBalance) / 100;
            let amountPair = ethers.parseUnits(
                `${amount}`,
                lpDetails?.currencyMetadata?.decimals,
            );
            const transaction = prepareContractCall({
                contract,
                method: "function removeLiquidity(address tokenA, address tokenB, uint256 liquidity, uint256 amountAMin, uint256 amountBMin, address to, uint256 deadline) returns (uint256 amountA, uint256 amountB)",
                params: [
                    lpDetails?.token0Address,
                    lpDetails?.token1Address,
                    amountPair,
                    calculateMinAmount(token0Amount.toFixed(3), lpDetails?.tokenOMetaData?.decimals),
                    calculateMinAmount(token1Amount.toFixed(3), lpDetails?.token1MetaData?.decimals),
                    address,
                    Math.floor(new Date().getTime() / 1000) + 900,
                ],
            });
            console.log(
                "%c Line:280 🧀 transaction",
                "color:#465975",
                transaction,
            );
            const txData = await sendTx({ transaction, account: add });
            console.log("%c Line:173 🥐 txData", "color:#3f7cff", txData);
            toast.success("Liquidity Removed Successfully");
            setLoading(false);

            // Navigate back to pool page with refresh state
            navigate('/pool', { state: { refresh: true } });
        } catch (error) {
            toast.error(error?.message);
            setLoading(false);
            console.log("%c Line:166 🍕 error", "color:#f5ce50", error);
        }
    };

    return (
        <div className="w-full max-w-[480px] flex flex-col card-3d p-6">
            {/* Header */}
            <div className="flex justify-between items-center mb-5">
                <button
                    className="swap-arrow-3d w-9 h-9 flex items-center justify-center"
                    onClick={() => navigate('/pool')}
                >
                    <FaArrowLeft className="size-[14px] text-dexora-text-secondary" />
                </button>
                <h2 className="text-[20px] font-bold gradient-text">
                    Remove Liquidity
                </h2>
                <button
                    className="swap-arrow-3d w-9 h-9 flex items-center justify-center"
                    onClick={() => setSettingsOpen(true)}
                    title="Slippage Settings"
                >
                    <IoSettings className="size-[18px] text-dexora-text-secondary" />
                </button>
            </div>

            {/* Remove Amount Section */}
            <div className="inner-3d p-5 mb-3">
                <div className="flex justify-between items-center mb-2">
                    <span className="text-[12px] font-semibold text-dexora-text-muted uppercase tracking-widest">
                        Remove Amount
                    </span>
                </div>
                <p className="text-[64px] text-left font-bold gradient-text leading-none mb-3">
                    {value}%
                </p>
                <input
                    type="range"
                    min="1"
                    max="100"
                    value={value}
                    disabled={!dataLoaded}
                    className={`w-full outline-none slider ${!dataLoaded ? 'opacity-40 cursor-not-allowed' : ''}`}
                    style={{
                        background: `linear-gradient(to right, rgb(var(--dexora-cyan)) ${value}%, rgba(255, 255, 255, 0.08) ${value}%)`,
                    }}
                    onChange={(e) => dataLoaded && updateValue(e.target.value)}
                />
                <div className="flex justify-between items-center w-full mt-4 gap-2">
                    {["25", "50", "75", "100"].map((v) => (
                        <button
                            key={v}
                            disabled={!dataLoaded}
                            onClick={() => dataLoaded && updateValue(v)}
                            className={`flex-1 text-[13px] font-bold py-2.5 rounded-xl transition-all ${
                                !dataLoaded
                                    ? "inner-3d text-dexora-text-muted cursor-not-allowed opacity-50"
                                    : value === v
                                    ? "btn-3d text-dexora-dark"
                                    : "inner-3d text-dexora-text-secondary hover:text-dexora-cyan"
                            }`}
                        >
                            {v === "100" ? "Max" : `${v}%`}
                        </button>
                    ))}
                </div>
            </div>

            {/* Arrow */}
            <div className="flex justify-center -my-4 z-10">
                <div className="swap-arrow-3d w-10 h-10 flex items-center justify-center">
                    <svg className="w-5 h-5 text-dexora-text-secondary" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 14l-7 7m0 0l-7-7m7 7V3" /></svg>
                </div>
            </div>

            {/* Output Section */}
            <div className="inner-3d p-4 mt-1 mb-3">
                {!dataLoaded ? (
                    <>
                        <div className="flex items-center justify-between py-2">
                            <div className="h-5 w-20 rounded bg-white/5 animate-pulse" />
                            <div className="flex gap-2 items-center">
                                <div className="size-[20px] rounded-full bg-white/5 animate-pulse" />
                                <div className="h-4 w-12 rounded bg-white/5 animate-pulse" />
                            </div>
                        </div>
                        <div className="border-t border-dexora-dark-tertiary/30 my-1"></div>
                        <div className="flex items-center justify-between py-2">
                            <div className="h-5 w-20 rounded bg-white/5 animate-pulse" />
                            <div className="flex gap-2 items-center">
                                <div className="size-[20px] rounded-full bg-white/5 animate-pulse" />
                                <div className="h-4 w-12 rounded bg-white/5 animate-pulse" />
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="flex items-center justify-between py-2">
                            <span className="text-dexora-text-primary text-[18px] font-bold">
                                {token0Amount.toFixed(3)}
                            </span>
                            <div className="flex gap-2 items-center">
                                {getTokenIcon(lpDetails?.token0Address) ? (
                                    <img src={getTokenIcon(lpDetails?.token0Address)} alt={lpDetails?.token0Symbol} className="size-[20px] rounded-full ring-1 ring-white/10" />
                                ) : (
                                    <div className="size-[20px] rounded-full bg-dexora-cyan/20 flex items-center justify-center text-[10px] font-bold text-dexora-cyan ring-1 ring-white/10">
                                        {lpDetails?.token0Symbol?.[0] || '?'}
                                    </div>
                                )}
                                <span className="text-dexora-text-primary text-[16px] font-bold">
                                    {lpDetails?.token0Symbol}
                                </span>
                            </div>
                        </div>
                        <div className="border-t border-dexora-dark-tertiary/30 my-1"></div>
                        <div className="flex items-center justify-between py-2">
                            <span className="text-dexora-text-primary text-[18px] font-bold">
                                {token1Amount.toFixed(3)}
                            </span>
                            <div className="flex gap-2 items-center">
                                {getTokenIcon(lpDetails?.token1Address) ? (
                                    <img src={getTokenIcon(lpDetails?.token1Address)} alt={lpDetails?.token1Symbol} className="size-[20px] rounded-full ring-1 ring-white/10" />
                                ) : (
                                    <div className="size-[20px] rounded-full bg-dexora-cyan/20 flex items-center justify-center text-[10px] font-bold text-dexora-cyan ring-1 ring-white/10">
                                        {lpDetails?.token1Symbol?.[0] || '?'}
                                    </div>
                                )}
                                <span className="text-dexora-text-primary text-[16px] font-bold">
                                    {lpDetails?.token1Symbol}
                                </span>
                            </div>
                        </div>
                    </>
                )}
            </div>

            {/* Price Info */}
            <div className="inner-3d p-3 mb-4">
                {!dataLoaded ? (
                    <div className="flex justify-between items-center">
                        <span className="text-dexora-text-muted text-[12px] font-semibold uppercase tracking-wider">Price</span>
                        <div className="flex flex-col items-end gap-1">
                            <div className="h-3 w-32 rounded bg-white/5 animate-pulse" />
                            <div className="h-3 w-32 rounded bg-white/5 animate-pulse" />
                        </div>
                    </div>
                ) : (
                    <div className="flex justify-between items-center">
                        <span className="text-dexora-text-muted text-[12px] font-semibold uppercase tracking-wider">Price</span>
                        <div className="flex flex-col items-end gap-0.5">
                            <span className="text-dexora-text-secondary text-[12px] font-medium">
                                1 {lpDetails?.token0Symbol} = {lpDetails?.token0Price?.toFixed(3)} {lpDetails?.token1Symbol}
                            </span>
                            <span className="text-dexora-text-secondary text-[12px] font-medium">
                                1 {lpDetails?.token1Symbol} = {lpDetails?.token1Price?.toFixed(3)} {lpDetails?.token0Symbol}
                            </span>
                        </div>
                    </div>
                )}
            </div>

            {/* Action Buttons */}
            <div className="flex items-center gap-3 w-full">
                {!dataLoaded ? (
                    <div className="w-full py-4 rounded-xl bg-white/5 animate-pulse h-[56px]" />
                ) : lpDetails && lpDetails?.approvedBalance <= 0 ? (
                    <button
                        className={`w-full py-4 text-[16px] font-bold btn-3d ${loading ? "text-dexora-text-muted" : "text-dexora-dark"}`}
                        disabled={loading}
                        onClick={() => !loading && approveTokenFun(lpDetails?.pairAddress)}
                    >
                        {loading ? "Approving..." : "Approve"}
                    </button>
                ) : (
                    ""
                )}
                {dataLoaded && lpDetails?.approvedBalance > 0 && (
                    <button
                        className={`w-full py-4 text-[16px] font-bold btn-3d ${
                            loading || !lpDetails?.pairAddress || value === 0
                                ? "text-dexora-text-muted"
                                : "text-dexora-dark"
                        }`}
                        disabled={loading || !lpDetails?.pairAddress || value === 0}
                        onClick={removeLiquidity}
                    >
                        {loading ? "Removing..." : "Remove Liquidity"}
                    </button>
                )}
            </div>
            <SlippageSettings
                open={settingsOpen}
                setOpen={setSettingsOpen}
                slippage={slippage}
                setSlippage={setSlippage}
            />
        </div>
    );
};

export default RemoveLiquidity;
